import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { url } from 'src/config';
import { orgId } from 'src/constants';
import { isLoading } from './isLoading';

const initialState = {
  userCallsLog: null,
  systemSettings: null,
  templates: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserCallsLog(state, action) {
      const { returnedRecords } = action.payload;
      state.userCallsLog = returnedRecords;
    },
    getSystemSettings(state, action) {
      state.systemSettings = action.payload;
    },
    createTemplate(state, action) {
      state.templates = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const getUserCallsLog = (data = {}) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);
    const response = await axios.post(`${url}user-calls-log/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseData } = response.data;
    dispatch(slice.actions.getUserCallsLog(responseData));
    dispatch(isLoading(false));
  } catch (err) {
    dispatch(isLoading(false));
  }
};

export const getSystemSettings = (data = {}) => async (dispatch) => {
  try {
    data.orgId = orgId;
    const response = await axios.post(`${url}system-settings/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseData, responseCode } = response.data;
    if (responseCode == '00') {
      const { companyInformation, lightOrDarkScreenMode } = responseData;
      localStorage.setItem(
        'CompanyNameShort',
        JSON.stringify(companyInformation.companyNameShort)
      );
      localStorage.setItem(
        'lightOrDarkScreenMode',
        JSON.stringify(lightOrDarkScreenMode.toUpperCase())
      );
      dispatch(slice.actions.getSystemSettings(responseData));
    }
  } catch (err) {
    console.log(err);
  }
};

export const createTemplate = (data) => async (dispatch) => {
  try {
    dispatch(slice.actions.createTemplate(data));
  } catch (err) {
    console.log(err);
  }
};

export default slice;
